import UnivercityDashboard from '../../assets/upgrade-images/university_admin_dashboard.svg'
import UniversityBadge from '../../assets/upgrade-images/university_admin_badge.svg'
import EntrepreneurialIcon from '../../assets/img/EntrepreneuriaICon.svg'
import ContactIocn from "../../assets/img/contactIocn.svg"

export let sidebarStaticData = {
    udc_admin: [
        {
            listName: 'Dashboard',
            manuName: 'organization-sideBar',
            path: '/org-dashboard',
            iconImage: UnivercityDashboard
        },
        {
            listName: 'Overall-Score',
            manuName: 'organization-sideBar',
            path: '/student-score',
            iconImage: UniversityBadge
        },

    ],
     entrepreneur: [
    {
      manuName: "entrepreneur",
      listName: "Entrepreneurial",
      path: "/entrepreneur",
     iconImage: EntrepreneurialIcon,
    },
    
  ],
    contactus: [
        {
            manuName: "contactus",
            listName: "Contact Us",
            path: "/contactus",
            iconImage: ContactIocn,
        },
    ],


  games: [
    {
      manuName: "games",
      listName: "Games",
      path: "/games",
    },
  ],
    prolific_admin: [
        {
            listName: 'Dashboard',
            manuName: 'organization-sideBar',
            path: '/org-dashboard',
            iconImage: UnivercityDashboard
        },
    ],
    super_admin: [
        {
            listName: 'Dashboard',
            manuName: 'Dashboard',
            path: '/admin',
            iconName: 'home icon sidebar-menu-icon'
        },
        {
            listName: 'Reporting',
            manuName: 'Reporting',
            path: '/reporting/assessment',
            iconName: 'file alternate icon sidebar-menu-icon'
        },
        {
            listName: 'Games Dashboard',
            manuName: 'Games-Dashboard',
            path: '/admin/game_dashboard',
            iconName: 'game icon sidebar-menu-icon'
        },
        {
            listName: 'Games Reporting',
            manuName: 'Games-Reporting',
            path: '/reporting/games',
            iconName: 'newspaper icon sidebar-menu-icon'
        },
        {
            listName: 'New Registrations',
            manuName: 'New-Registrations',
            path: '/recent_registrations',
            iconName: 'edit icon sidebar-menu-icon'
        },
        {
            listName: 'Researchers',
            manuName: 'Researchers',
            path: '/researchers',
            iconName: 'searchengin icon sidebar-menu-icon'
        },
        {
            listName: 'Survey Data',
            manuName: 'Survey-Data',
            path: '/survey-data',
            iconName: 'table icon sidebar-menu-icon'
        },
        {
            listName: 'Games Data',
            manuName: 'Games-Data',
            path: '/games-data',
            iconName: 'calendar alternate  icon sidebar-menu-icon'
        }

    ],
    reporting_user: [
        {
            listName: 'Reports',
            manuName: 'Reports',
            path: '/repoting-page',
            iconName: 'newspaper icon sidebar-menu-icon',
            subNavs: [
                {
                    listName: 'Resilience',
                    manuName: 'Resilience',
                    path: { pathname: "/repoting-page", state: { activeConstruct: 'Resilience', subNav: 'Resilience' } },
                },
                {
                    listName: 'Persistence',
                    manuName: 'Persistence',
                    path: { pathname: "/repoting-page", state: { activeConstruct: 'Persistence', subNav: 'Persistence' } },
                },
                {
                    listName: 'Challenge seeking',
                    manuName: 'Challenge seeking',
                    path: { pathname: "/repoting-page", state: { activeConstruct: 'ChallengeSeeking', subNav: 'ChallengeSeeking' } },
                },
                // {
                //     listName: 'Info seeking',
                //     manuName: 'Info seeking',
                //     path: { pathname: "/repoting-page", state: { activeConstruct: 'InformationSeeking', subNav: 'InformationSeeking' } },
                // },
                {
                    listName: 'Problem Solving',
                    manuName: 'Problem Solving',
                    path: { pathname: "/repoting-page", state: { activeConstruct: 'ProblemSolving', subNav: 'ProblemSolving' } },
                },
                {
                    listName: 'Goal Setting',
                    manuName: 'Goal Setting',
                    path: { pathname: "/repoting-page", state: { activeConstruct: 'GoalSetting', subNav: 'GoalSetting' } },
                },
                {
                    listName: 'Divergent thinking',
                    label: 'Divergent thinking',
                    path: { pathname: "/repoting-page", state: { activeConstruct: 'DivergentThinking', subNav: 'DivergentThinking' } },
                },
            ],
        }
    ]
}

